import React from "react";
import MultipleSelect from "features/Admin/components/NewMultipleSelect";

const AnalysesForm = ({ element, updateAnalyses, analysesFactory }) => (
	<div>
		<MultipleSelect update={updateAnalyses} factory={analysesFactory} order="true" />
	</div>
);

export default AnalysesForm;
